module.exports = __webpack_public_path__ + "img/location.74afdeab.svg";